import axios from 'axios';
import Cookies from 'js-cookie';
import jwt_decode from 'jwt-decode';
// import { REACT_APP_API_BASE_URL_LOCAL, REACT_APP_ENV, REACT_APP_API_BASE_URL_DEV } from './constant';
import { REACT_APP_API_BASE_URL, REACT_APP_ENV } from './constant';

// const isDevelopment = REACT_APP_ENV == 'DEV';
// const myBaseUrl = isDevelopment ? REACT_APP_API_BASE_URL_DEV : REACT_APP_API_BASE_URL_LOCAL;

const apiInstance = axios.create({
    baseURL: REACT_APP_API_BASE_URL,
    timeout: REACT_APP_ENV == 'DEV' ? 100000 : 5000, //ms
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    }
});

apiInstance.interceptors.request.use(
    (config) => {
      const token = Cookies.get('access_token'); // Or Cookies.get('token') localStorage.getItem('token');

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

export default apiInstance